import { brand } from '@/styles/shared';
export const logoutButtonStyle = (isMobile: boolean) => ({
  borderRadius: '40px',
  width: isMobile
    ? '125px'
    : {
        xs: '125px',
        sm: '140px',
        md: '198px',
      },
  height: {
    sx: '35px',
    sm: '38px',
    md: '40px',
  },
  background: 'rgba(112, 37, 200, 1)',
  wordBreak: 'keep-all',
  color: 'white',
  textTransform: 'none',
  border: '2px solid #bb04fe',
  fontSize: isMobile
    ? ' 0.8rem'
    : {
        xs: '0.8rem',
        sm: '0.8em',
        md: '1rem',
      },
  lineHeight: '17px',
  margin: '10px 0px 10px 0px',
  fontWeight: 500,
});

export const logoutStyles = {
  logoutButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 16px',
    backgroundColor: brand.purpleAccent,
    borderRadius: '8px',
    cursor: 'pointer',
    border: 'none',
    '&:hover': {
      opacity: 0.7,
    },
  },
  logoutText: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#ffffff',
  },
  logoutIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};
